/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_ConfirmInputs */

const cs_property_ai_confirm = /** @type {(inputs: Property_Ai_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit překlad`)
};

const en_property_ai_confirm = /** @type {(inputs: Property_Ai_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm translation`)
};

/**
* | output |
* | --- |
* | "Confirm translation" |
*
* @param {Property_Ai_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_confirm = /** @type {((inputs?: Property_Ai_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_confirm(inputs)
	return cs_property_ai_confirm(inputs)
});